import unauthorizedComponent from './unauthorized.component';

const unauthorizedModule = angular
  .module('unauthorized', [])
  .component('unauthorized', unauthorizedComponent);

export default unauthorizedModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/errors/unauthorized/unauthorized.js
 **/